import { styled } from "@mui/system";
import { Box } from "@mui/material";
import { Form } from "formik";

export const FlexContainer = styled(Box)(({ theme }) => ({
  marginTop: "0",
  marginBottom: "0"
}));

export const ButtonWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  margin: "0 0 40px 0"
}));

export const FormContainer = styled(Form)(({ theme }) => ({
  width: "100%",
  "& .MuiGrid-root": {
    "&> .MuiGrid-item": {
      paddingTop: "24px"
    }
  }
}));
